import { SizeCode } from 'entities/SizeCode';
import { roundNumber } from 'shared/utils/helpers/roundNumber';

interface Args {
  shapeWidth: number;
  shapeLength: number;
  availableSizeCodes: SizeCode[] | undefined;
  pixelsPerMeter: number;
}

export const getNearestSizeCode = ({ shapeWidth, shapeLength, availableSizeCodes, pixelsPerMeter }: Args): SizeCode | undefined => {
  if (!availableSizeCodes?.length) return undefined;

  const shapeSquare = roundNumber((shapeWidth / pixelsPerMeter) * (shapeLength / pixelsPerMeter));

  const closestSize = availableSizeCodes.reduce((prev, curr) => {
    return Math.abs(curr.square - shapeSquare) < Math.abs(prev.square - shapeSquare) ? curr : prev;
  });

  return closestSize;
};
